import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import IconPlus from 'cccisd-icons/plus-circle2';

import CaregiverForm from 'js/components/CaregiverForm';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;

const AddCaregiver = props => {
    const modal = useRef();
    const currentRole = Fortress.user && Fortress.user.acting.role.handle;
    const hasFixedSite = currentRole === 'supervisor' || currentRole === 'careCoordinator';

    const onSubmit = async values => {
        const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
            role: 'caregiver',
            caregiverName: values.caregiverName,
            caregiverPhone: values.caregiverPhone,
            caregiverEmail: values.caregiverEmail,
            caregiverLanguage: values.caregiverLanguage,
            caregiverSpecifyLanguage: values.caregiverSpecifyLanguage,
            caregiverAddress: values.caregiverAddress,
            caregiverCity: values.caregiverCity,
            caregiverState: values.caregiverState,
            caregiverZipCode: values.caregiverZipCode,
            receiveMessages: values.receiveMessages,
            group: values.site,
            childPawns: JSON.stringify(values.youth),
            parentPawns: JSON.stringify(values.careCoordinator),
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ type: 'danger', message: errorMessage });
            return Promise.reject(response.data.errors);
        }

        await props.loadData();
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <IconPlus spaceRight />
                    Add Caregiver
                </button>
            }
            title="Add New Caregiver"
        >
            <CaregiverForm
                onSubmit={onSubmit}
                initialValues={{
                    caregiverName: '',
                    caregiverPhone: '',
                    caregiverEmail: '',
                    caregiverLanguage: '',
                    caregiverSpecifyLanguage: '',
                    caregiverAddress: '',
                    caregiverCity: '',
                    caregiverState: '',
                    caregiverZipCode: '',
                    receiveMessages: true,
                    site: hasFixedSite && Fortress?.user?.acting?.group?.id ? [Fortress.user.acting.group.id] : [],
                    careCoordinator: currentRole === 'careCoordinator' ? [Fortress.user.acting.id] : [],
                    youth: [],
                }}
            />
        </Modal>
    );
};

AddCaregiver.propTypes = {
    loadData: PropTypes.func,
};

export default AddCaregiver;
